import store, { history } from '../store';

const redirect = () => {
  const state = store.getState();
  const { user } = state;
  const { userTeams } = state.teams;

  const currentPath = window.location.pathname;

  // If redirecting within the same template use history.push to avoid page reload.
  // Otherwise use window.location to get the new page layout.
  const isSignup = currentPath.indexOf('/signup') === 0;

  // If there is no user redirect to the signup page
  if (user.id === null) {
    if (isSignup) {
      history.push('/signup');
      return '';
    }

    window.location = '/signup';
    return '';
  }

  // If all of the above criteria is met and the user is in the signup area redirect them
  // to the product management area
  if (isSignup) {
    window.location = '/products';
  }

  if (RegExp('^/product-management/?$').test(currentPath)) {
    history.push('/products');
  }
};

export default redirect;
